import { stringEnum } from 'common/utils/objects';
import { EnumValues } from 'common/types';

export const PAGES = stringEnum(['general', 'home', 'about']);
export type CustomizerPage = EnumValues<typeof PAGES>;
